<template>
    <div class="visitor-activities">
        <div class="activities" v-if="!!activitiesClone.length">
            <vue-scroll class="scroll">
                <div
                    v-for="activity of activitiesClone"
                    class="activity-item"
                    @click="showDetails(activity.id)"
                    :class="opened == activity.id && 'show-details'"
                >
                    <div class="activity-info">
                        <div class="activity-type">
                            <div class="material-icons">{{ detailOption[activity.type].icon }}</div>
                        </div>
                        <div class="activity-about">
                            <div class="activity-about-title">{{ detailOption[activity.type].text }}</div>
                            <div class="activity-about-date">{{ $moment(activity.createdAt).fromNow() }}</div>
                        </div>
                    </div>
                    <div
                        class="activity-details"
                        v-if="
                            [
                                // hangi actionlarda detail varsa
                                'visitor-profile-updated',
                                'blocked',
                                'unblocked',
                                'create-ticket',
                                'visitor-tag-added',
                                'visitor-tag-removed',
                                'note-created',
                                'note-updated',
                                'page-changed',
                                'chat-opened',
                            ].includes(activity.type)
                        "
                    >
                        <template v-if="activity.actorUser">
                            <div class="activity-add">
                                <div class="material-icons">person</div>
                                {{ activity.actorUser.name }}
                            </div>
                        </template>
                        <template v-if="['visitor-tag-added', 'visitor-tag-removed'].includes(activity.type)">
                            <div class="activity-add" v-if="!isArray(activity.payload)">
                                <div class="material-icons">add</div>
                                {{ activity.payload.tagName }}
                            </div>
                            <div class="activity-add" v-else v-for="tag of activity.payload">
                                <div class="material-icons">add</div>
                                {{ tag.tagName }}
                            </div>
                        </template>
                        <template v-if="activity.type == 'visitor-profile-updated'">
                            <template v-for="key of Object.keys(activity.payload)">
                                <template v-if="visitorAttributes[key]">
                                    <div class="activity-add">
                                        <div class="material-icons">add</div>
                                        <b>{{ visitorAttributes[key].label }} </b>: {{ activity.payload[key].newVal }}
                                    </div>
                                    <div class="activity-add">
                                        <div class="material-icons">remove</div>
                                        <b>{{ visitorAttributes[key].label }} </b>:
                                        {{ activity.payload[key].oldVal || "N/A" }}
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="activity-add">
                                        <div class="material-icons">add</div>
                                        <b>{{ $_.startCase(key) }} </b>: {{ activity.payload[key].newVal }}
                                    </div>
                                    <div class="activity-add">
                                        <div class="material-icons">remove</div>
                                        <b>{{ $_.startCase(key) }} </b>: {{ activity.payload[key].oldVal || "N/A" }}
                                    </div>
                                </template>
                            </template>
                        </template>
                        <template v-if="activity.type == 'note-created'">
                            <div class="activity-add">
                                <div class="material-icons">add</div>
                                {{ activity.payload.note }}
                            </div>
                        </template>
                        <template v-if="activity.type == 'note-updated'">
                            <div class="activity-add">
                                <div class="material-icons">add</div>
                                {{ activity.payload.newNote }}
                            </div>
                            <div class="activity-add">
                                <div class="material-icons">remove</div>
                                {{ activity.payload.oldNote }}
                            </div>
                        </template>
                        <template v-if="activity.type == 'chat-opened' && activity.payload.visitorDetail">
                            <div class="activity-add" v-if="activity.payload.visitorDetail.fullname">
                                <div class="material-icons">badge</div>
                                {{ activity.payload.visitorDetail.fullname.oldVal }} ->
                                {{ activity.payload.visitorDetail.fullname.newVal }}
                            </div>
                            <div class="activity-add" v-if="activity.payload.visitorDetail.email">
                                <div class="material-icons">mail</div>
                                {{ activity.payload.visitorDetail.email.oldVal }} ->
                                {{ activity.payload.visitorDetail.email.newVal }}
                            </div>
                        </template>
                        <template v-if="activity.type == 'create-ticket'">
                            <div class="activity-add">
                                <div class="material-icons">sticky_note_2</div>
                                {{ activity.payload.osrPayload.message }}
                            </div>
                        </template>
                    </div>
                </div>
            </vue-scroll>
        </div>
        <div class="data-box" v-else>
            <div class="last-session-info">
                <div class="material-icons" style="font-size: 20px">block</div>
                <div class="last-session-data" style="margin-top: 5px">No user data were found</div>
            </div>
        </div>
    </div>
</template>

<script>
import { log2 } from "../../../utils/log2";
import { mapState } from "vuex";

const log = log2("VisitorActivities");

export default {
    name: "VisitorActivities",
    components: {},
    props: {
        activities: {
            type: Array,
            default: [],
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        opened: null,
        //TODO: Bu kısımlara dil çeviri sistemi getirilmesi lazım.
        detailOption: {
            offline: {
                icon: "wifi_off",
                text: "Kullanıcının websitesinden bağlantısı kesildi.",
            },
            online: {
                icon: "wifi",
                text: "Kullanıcı websitesine bağlandı.",
            },
            "chat-opened": {
                icon: "add_comment",
                text: "Kullanıcı yeni bir sohbet oluşturdu.",
            },
            "chat-closed": {
                icon: "comments_disabled",
                text: "Kullanıcı sohbeti sonlandırıldı.",
            },
            blocked: {
                icon: "gavel",
                text: "Kullancı yasaklandı.",
            },
            unblocked: {
                icon: "recommend",
                text: "Kullanıcın yasağı kaldırıldı.",
            },
            "create-ticket": {
                icon: "confirmation_number",
                text: "Kullanıcı yeni bir ticket oluşturdu",
            },
            "video-calling-started": {
                icon: "video_call",
                text: "Kullanıcı bir görüntülü aramaya katıldı.",
            },
            "video-calling-closed": {
                icon: "missed_video_call",
                text: "Kullanıcının görüntülü konuşması sonlandırıldı.",
            },
            "voice-calling-started": {
                icon: "mic",
                text: "Kullanıcı bir sesli aramaya katıldı.",
            },
            "voice-calling-closed": {
                icon: "mic_off",
                text: "Kullanıcının sesli arama konuşması sonlandırıldı.",
            },
            "visitor-tag-added": {
                icon: "new_label",
                text: "Kullanıcıya yeni etiket eklendi.",
            },
            "visitor-tag-removed": {
                icon: "label_off",
                text: "Kullanıcıdan bir etiket kaldırıldı.",
            },
            "note-created": {
                icon: "description",
                text: "Kullanıcıya yeni bir not eklendi.",
            },
            "note-updated": {
                icon: "edit_note",
                text: "Kullanıcı notu güncellendi.",
            },
            "chat-rating": {
                icon: "reviews",
                text: "Kullanıcı chat puanladı.",
            },
            "page-changed": {
                icon: "history",
                text: "Kullanıcı sayfa değiştirdi.",
            },
            "visitor-profile-updated": {
                icon: "manage_accounts",
                text: "Kullanıcı profili güncellendi.",
            },
        },
        activitiesClone: [],
    }),
    methods: {
        showDetails(id) {
            this.opened = this.opened !== id && id;
        },
        isArray(data) {
            return data instanceof Array;
        },
        smashActivities() {
            this.activitiesClone = this.$_.cloneDeep(this.activities);
            if (this.type == "connect_log") {
                this.activitiesClone = this.activitiesClone.filter((activity) =>
                    ["online", "offline"].includes(activity.type)
                );
            } else {
                this.activitiesClone = this.activitiesClone.filter(
                    (activity) => !["online", "offline"].includes(activity.type)
                );
            }
        },
    },
    mounted() {
        this.smashActivities();
    },
    computed: {
        ...mapState({
            visitorAttributes: (state) =>
                (state.contactProperty.data || []).reduce((a, b) => {
                    a[b._id] = b;
                    return a;
                }, {}),
        }),
    },
    watch: {
        activities: {
            handler() {
                this.smashActivities();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.visitor-activities {
    .activities {
        color: var(--color7) !important;
        display: flex;
        flex-direction: column;
        top: 90px;
        bottom: 30px;
        width: 100%;
        border-left: 1px solid #dbe1e8;
        border-right: 1px solid #dbe1e8;
        border-top: 1px solid #dbe1e8;
        border-radius: 4px;
        max-height: 350px;
        overflow-y: auto;

        .scroll .__bar-is-vertical {
            background: #ffa800 !important;
        }

        .last-session-data {
            max-width: 200px;
            color: #516173;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
        }

        .data-box {
            border: 1px solid #dbe1e8;
            border-radius: 4px;
            -webkit-box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
            box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
            padding: 25px;
            display: grid;
            width: 100%;
        }

        .last-session-info {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .activity-item {
            width: 100%;
            padding: 10px 10px;
            border-bottom: 1px solid #dbe1e8;
            position: relative;
            overflow: hidden;
            height: 70px;
            transition: all 1s;
            cursor: pointer;

            &.show-details {
                height: auto;
            }

            .activity-info {
                display: flex;
                align-items: center;

                .activity-type {
                    background-color: #fff4de;
                    height: 50px;
                    width: 50px;
                    border-radius: 100px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-weight: bold;
                    margin-right: 10px;

                    .material-icons {
                        color: #ffa800;
                    }
                }

                .activity-about {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;

                    .activity-about-title {
                        font-size: 16px;

                        span {
                            font-weight: bold;
                        }
                    }

                    .activity-about-date {
                        font-size: 12px;
                        margin-right: 5px;
                    }
                }
            }

            .activity-details {
                border-top: 1px solid #dbe1e8;
                margin-top: 10px;
                padding-top: 10px;

                .activity-add {
                    display: flex;
                    align-items: center;

                    .material-icons {
                        margin-right: 3px;
                        color: #ffa800;
                    }
                }
            }
        }
    }
}
</style>
